<template>
  <div>
    <PrivacyAgreement :show="showAgreePrivacy" @close="handlerCloseAgreePrivacy" />
    <div style="width: 1680px; padding: 10px; display: flex; cursor: pointer">
      <div style="width: 1248px; margin-right: 20px">
        <div style="display: flex">
          <el-card shadow="hover" :body-style="{ padding: '15px', width: '330px' }" style="margin-right: 10px">
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 36px;
                  height: 36px;
                  background-color: #87a5ff;
                  margin-right: 10px;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <span class="el-icon-set-up" style="font-size: 17px; color: #ffffff"></span>
              </div>
              <div style="font-size: 16px; height: 36px; line-height: 36px; color: #7b7b7b; font-weight: bold">
                {{ $t("consoles.sbdl") }}
              </div>
            </div>
            <div style="display: flex; width: 100%; align-items: center; justify-content: center; margin-top: 5px">
              <div style="font-size: 16px; height: 30px; line-height: 30px">
                <span
                  style="
                    font-size: 30px;
                    font-weight: 500;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #00a4f0;
                    font-weight: bold;
                  "
                  >{{ machines["equipmentTotalNum"] }}</span
                >
                <span style="font-size: 14px; color: #999">{{ $t("consoles.tai") }}</span>
              </div>
            </div>
            <div style="display: flex; width: 100%; align-items: center; justify-content: center; margin-top: 15px">
              <div style="width: 33.3333%; text-align: center">
                <div style="font-size: 12px; color: #77cc48; font-weight: bold">
                  {{ machines["equipmentMqYesNum"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.zxsb") }}
                </div>
              </div>
              <div style="width: 33.3333%; text-align: center">
                <div style="font-size: 12px; color: #f50f38; font-weight: bold">
                  {{ machines["equipmentMqNoNum"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.lxsb") }}
                </div>
              </div>
            </div>
          </el-card>
          <el-card shadow="hover" :body-style="{ padding: '15px', width: '490px' }" style="margin-right: 10px">
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 36px;
                  height: 36px;
                  background-color: #ff6b72;
                  margin-right: 10px;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <span class="el-icon-s-data" style="font-size: 17px; color: #ffffff"></span>
              </div>
              <div style="font-size: 16px; height: 36px; line-height: 36px; color: #7b7b7b; font-weight: bold">
                {{ $t("consoles.jrxse") }}
              </div>
            </div>
            <div style="display: flex; width: 100%; align-items: center; justify-content: center; margin-top: 5px">
              <div style="font-size: 16px; height: 30px; line-height: 30px; color: #ff6b72">
                <span style="font-size: 14px">$</span>
                <span
                  style="
                    font-size: 30px;
                    font-weight: 500;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-weight: bold;
                  "
                  >{{ daySales["todaySales"] }}</span
                >
              </div>
            </div>
            <div style="display: flex; width: 100%; align-items: center; justify-content: center; margin-top: 15px">
              <div style="width: 25%; text-align: center">
                <div style="font-size: 12px; color: #00a6ef; font-weight: bold">
                  {{ daySales["yesterdaySales"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.zrxse") }}
                </div>
              </div>
              <div style="width: 25%; text-align: center">
                <div style="font-size: 12px; color: #00a6ef; font-weight: bold">
                  {{ daySales["weekSales"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.bzxse") }}
                </div>
              </div>
              <div style="width: 25%; text-align: center">
                <div style="font-size: 12px; color: #00a6ef; font-weight: bold">
                  {{ daySales["monthSales"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.byxse") }}
                </div>
              </div>
              <div style="width: 25%; text-align: center">
                <div style="font-size: 12px; color: #00a6ef; font-weight: bold">
                  {{ daySales["sales"] }}
                </div>
                <div style="font-size: 12px; color: #7b7b7b">
                  {{ $t("consoles.zdxse") }}
                </div>
              </div>
            </div>
          </el-card>
        </div>
        <div
          style="
            width: 100%;
            margin-top: 15px;
            height: 50px;
            background-color: #f3f3f3;
            border: 1px solid #e7e7e7;
            border-radius: 3px;
            font-weight: normal;
          "
        >
          <div
            style="float: left; font-size: 18px; line-height: 50px; height: 50px; margin-left: 10px; font-size: 16px"
          >
            {{ $t("consoles.syzxyl") }}
          </div>
          <div
            style="float: right; font-size: 18px; line-height: 50px; height: 50px; margin-right: 10px; font-size: 15px"
          >
            <span
              @click="HandlerPSItem(1)"
              :class="PSItem == 1 ? 'activeyanse' : 'yanse'"
              style="margin-right: 20px; cursor: pointer"
              >{{ $t("consoles.yitian") }}</span
            >
            <span
              @click="HandlerPSItem(2)"
              :class="PSItem == 2 ? 'activeyanse' : 'yanse'"
              style="margin-right: 20px; cursor: pointer"
              >{{ $t("consoles.yizhou") }}</span
            >
            <span
              @click="HandlerPSItem(3)"
              :class="PSItem == 3 ? 'activeyanse' : 'yanse'"
              style="margin-right: 20px; cursor: pointer"
              >{{ $t("consoles.yiyue") }}</span
            >
            <span :class="PSItem == 4 ? 'activeyanse' : 'yanse'" style="margin-right: 15px">{{
              $t("consoles.zixuan")
            }}</span>
            <el-date-picker
              @focus="HandlerPSItem(4)"
              v-model="datastringps"
              size="small"
              clear
              type="datetimerange"
              :range-separator="$t('consoles.zhistr')"
              :start-placeholder="$t('consoles.startdate')"
              :end-placeholder="$t('consoles.enddate')"
              :picker-options="pickerOptions"
              @change="handlerDatePickerPS"
              style="width: 335px; cursor: pointer"
            ></el-date-picker>
            <el-select
              v-model="weekcondition.searchType"
              @change="HandlerLeixingChange"
              :placeholder="$t('payment.select')"
              size="small"
              style="width: 200px; margin-left: 20px"
            >
              <el-option
                v-for="item in pcOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div
          id="DataVolumeStatistics"
          style="
            padding: 10px;
            margin-top: 15px;
            height: 400px;
            border: 1px solid #e7e7e7;
            border-radius: 3px;
            font-weight: normal;
          "
        ></div>
        <div
          style="
            width: 100%;
            height: 50px;
            margin-top: 15px;
            background-color: #f3f3f3;
            border: 1px solid #e7e7e7;
            border-radius: 3px;
            font-weight: normal;
          "
        >
          <div
            style="float: left; font-size: 18px; line-height: 50px; height: 50px; margin-left: 10px; font-size: 16px"
          >
            {{ $t("consoles.zhanweitu") }}
          </div>
          <div
            style="float: right; font-size: 18px; line-height: 50px; height: 50px; margin-right: 10px; font-size: 15px"
          >
            <el-date-picker
              @focus="HandlerPCItem(4)"
              v-model="datastringpc"
              type="datetimerange"
              size="small"
              :range-separator="$t('consoles.zhistr')"
              :start-placeholder="$t('consoles.startdate')"
              :end-placeholder="$t('consoles.enddate')"
              :picker-options="pickerOptions"
              @change="handlerDatePickerPC"
              style="width: 335px; cursor: pointer"
            ></el-date-picker>
          </div>
        </div>
        <div style="width: 100%; display: flex">
          <div
            id="PercentageChart1"
            style="
              width: 416px;
              padding: 5% 0;
              height: 300px;
              font-size: 17px;
              font-weight: bold;
              color: #303133;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          ></div>
          <div
            id="PercentageChart2"
            style="
              width: 416px;
              padding: 5% 0;
              height: 300px;
              font-size: 17px;
              font-weight: bold;
              color: #303133;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          ></div>
          <div
            id="PercentageChart3"
            style="
              width: 416px;
              padding: 5% 0;
              height: 300px;
              font-size: 17px;
              font-weight: bold;
              color: #303133;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          ></div>
        </div>
      </div>
      <div style="width: 412px; display: flow-root">
        <div style="border: 1px solid #ebeef5; padding: 15px 15px 0 15px">
          <div style="margin-bottom: 15px; font-weight: bold; font-size: 16px; color: #7b7b7b">
            {{ $t("consoles.xsph") }}
          </div>
          <div style="width: 100%; margin-bottom: 15px; display: flow-root">
            <el-date-picker
              v-model="SearchDataString"
              type="datetimerange"
              size="small"
              @change="PhHandlerDateChange"
              :range-separator="$t('consoles.zhistr')"
              :start-placeholder="$t('consoles.starttime')"
              :end-placeholder="$t('consoles.endtime')"
              :picker-options="pickerOptions"
              style="width: 100%"
            ></el-date-picker>
          </div>
          <div style="width: 100%; margin-bottom: 15px; display: flow-root">
            <el-select
              v-model="search.sort"
              @change="handlerSortChange"
              size="small"
              :placeholder="$t('payment.select')"
              style="width: 48%; margin-right: 2%"
            >
              <el-option
                v-for="item in pcOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-select v-if="activeName == 'third'" v-model="sbzhi" @change="handlerMachineChange" multiple :placeholder="$t('payment.select')" style="width: 48%; margin-left: 2%;">
              <el-option v-for="item in sbOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </div>
          <el-tabs v-model="activeName" @tab-click="HandleSwitcPage">
            <el-tab-pane v-loading="loading" :label="$t('consoles.yhb')" name="first">
              <div
                v-for="(item, index) in datasets"
                :key="index"
                style="
                  display: flow-root;
                  border: 1px solid rgb(235, 238, 245);
                  padding: 15px;
                  border-radius: 5px;
                  margin-bottom: 15px;
                "
              >
                <div style="display: flow-root; margin-bottom: 15px">
                  <div>{{ $t("consoles.yhzh") }}：{{ item["userName"] }}</div>
                  <div>{{ $t("consoles.yhnc") }}：{{ item["nickName"] }}</div>
                </div>
                <div style="display: flex; width: 100%">
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["sales"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xse") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["num"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xsl") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["cost"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zcb") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">
                      {{ item["profit"] }}
                    </div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zlr") }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="ismore == 1"
                style="
                  margin-bottom: 15px;
                  text-align: center;
                  font-size: 14px;
                  color: #7b7b7b;
                  cursor: pointer;
                  text-decoration: underline;
                "
              >
                查看更多
              </div>
              <div v-if="ismore == 0" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.qianwu") }}
              </div>
              <div v-if="ismore == 2" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.loading") }}
              </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loading" :label="$t('consoles.sbb')" name="second">
              <div
                v-for="(item, index) in datasets"
                :key="index"
                style="
                  display: flow-root;
                  border: 1px solid rgb(235, 238, 245);
                  padding: 15px;
                  border-radius: 5px;
                  margin-bottom: 15px;
                "
              >
                <div style="display: flow-root; margin-bottom: 15px">
                  <div>{{ $t("consoles.sbh") }}：{{ item["equipmentNo"] }}</div>
                  <div>{{ $t("consoles.sbm") }}：{{ item["equipmentName"] }}</div>
                </div>
                <div style="display: flex; width: 100%">
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["sales"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xse") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["num"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xsl") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">{{ item["cost"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zcb") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div style="font-size: 16px">
                      {{ item["profit"] }}
                    </div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zlr") }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="ismore == 1"
                style="
                  margin-bottom: 15px;
                  text-align: center;
                  font-size: 14px;
                  color: #7b7b7b;
                  cursor: pointer;
                  text-decoration: underline;
                "
              >
                查看更多
              </div>
              <div v-if="ismore == 0" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.qianwu") }}
              </div>
              <div v-if="ismore == 2" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.loading") }}
              </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loading" :label="$t('consoles.spb')" name="third">
              <div id="ProductChart" style="width: 100%; height: 300px"></div>
              <div
                v-for="(item, index) in datasets"
                :key="index"
                style="
                  display: flex;
                  border: 1px solid rgb(235, 238, 245);
                  padding: 15px;
                  border-radius: 5px;
                  margin-bottom: 15px;
                "
              >
                <div style="width: 43px; margin-right: 15px; display: flex; align-items: center">
                  <img :src="item['productImg']" style="width: 43px; height: 43px; display: block" />
                </div>
                <div style="width: 38%">{{ item["goodsName"] }}</div>
                <div style="width: 48%">
                  <div style="display: flex; width: 100%; margin-bottom: 10px">
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div style="font-size: 16px">
                        {{ item["sales"] }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.xse") }}
                      </div>
                    </div>
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div style="font-size: 16px">{{ item["num"] }}</div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.xsl") }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; width: 100%; margin-top: 10px">
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div style="font-size: 16px">
                        {{ item["cost"] }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.zcb") }}
                      </div>
                    </div>
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div style="font-size: 16px">
                        {{ item["profit"] }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.zlr") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="ismore == 1"
                style="
                  margin-bottom: 15px;
                  text-align: center;
                  font-size: 14px;
                  color: #7b7b7b;
                  cursor: pointer;
                  text-decoration: underline;
                "
              >
                load more
              </div>
              <div v-if="ismore == 0" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.qianwu") }}
              </div>
              <div v-if="ismore == 2" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: #7b7b7b">
                {{ $t("consoles.loading") }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  // import Intercom from "@intercom/messenger-js-sdk";
  import PrivacyAgreement from "@/components/PrivacyAgreement";
  let xAxisData = [];
  let DataVolumeStatistics = null;
  let PercentageChart1 = null;
  let PercentageChart2 = null;
  let PercentageChart3 = null;
  let ProductChart = null;
  export default {
    name: "Main",
    data() {
      return {
        activeName: "first",
        machines: {},
        daySales: {},
        datasets: [],
        search: {
          equipmentNo: "",
          startDate: "",
          endDate: "",
          sort: "num",
          order: "desc"
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        ismore: 2,
        SearchDataString: "",
        loading: false,
        pcOptions: [
          {
            value: "num",
            label: this.$t("consoles.axl")
          },
          {
            value: "sales",
            label: this.$t("consoles.axse")
          }
        ],
        sbOptions: [
          {
            value: "num",
            label: this.$t("consoles.axl")
          },
          {
            value: "sales",
            label: this.$t("consoles.axse")
          }
        ],
        sbzhi: "num",
        //  近一周销售量、销售额统计
        datastringps: "",
        pickerOptions: {
          shortcuts: [
            {
              text: this.$t("TimeControl.week"),
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: this.$t("TimeControl.month"),
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: this.$t("TimeControl.year"),
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        PSItem: 1,
        weekcondition: {
          startDate: "",
          endDate: "",
          searchType: "num", // num：销售量  sales：销售额
          type: 2
        },
        datastringpc: "",
        PCItem: 1,
        weekconditionpc: {
          startDate: "",
          endDate: ""
        },
        showAgreePrivacy: false
      };
    },
    components: {
      PrivacyAgreement
    },
    mounted() {
      let _self = this;
      // 是否展示隐私协议
      if (String(this.$route.query.showAgreePrivacy) === '0') {
        this.showAgreePrivacy = true;
        this.$store.commit('set', { privacyVisible: true });
      }
      DataVolumeStatistics = echarts.init(document.getElementById("DataVolumeStatistics"));
      PercentageChart1 = echarts.init(document.getElementById("PercentageChart1"), null, {
        width: 416
      });
      PercentageChart2 = echarts.init(document.getElementById("PercentageChart2"), null, {
        width: 416
      });
      PercentageChart3 = echarts.init(document.getElementById("PercentageChart3"), null, {
        width: 416
      });
      ProductChart = echarts.init(document.getElementById("ProductChart"), null, {
        width: 416
      });
      //  获取设备数量
      _self.getMachines();
      //  今日销售额
      _self.getDaySales();
      if (_self.activeName == "first") {
        _self.getSalesUser();
      } else if (_self.activeName == "second") {
        _self.getSalesMachine();
      } else if (_self.activeName == "third") {
        _self.getSalesProduct();
      }
      //  前7天
      //  设置日期，当前日期的前七天
      var flag = 1;
      var dateTemp;
      var myDate = new Date(); //获取今天日期
      var startDate = "";
      var endDate = "";
      myDate.setDate(myDate.getDate() - 7);
      for (var i = 0; i < 7; i++) {
        myDate.setDate(myDate.getDate() + flag);
        var year = myDate.getFullYear();
        var month = myDate.getMonth() + 1;
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var date = myDate.getDate();
        if (parseInt(date) < 10) {
          date = "0" + date;
        }
        //  底部菜单-获取周几
        dateTemp = year + "-" + month + "-" + date;
        if (i == 0) {
          //  开始日期
          startDate = dateTemp;
        } else if (i == 6) {
          //  结束日期
          endDate = dateTemp;
        }
      }
      //  获取统计数据
      _self.PSItem = 2;
      _self.weekcondition.startDate = startDate;
      _self.weekcondition.endDate = endDate;
      _self.BrokenLineStatisticsChart();
      //  占比图
      _self.PCItem = 2;
      _self.weekconditionpc.startDate = startDate;
      _self.weekconditionpc.endDate = endDate;
      _self.PercentageStatisticsChart();
    },
    methods: {
      // Intercom call
      //  showIntercom() {
      //   Intercom("show");
      //  },
      handlerCloseAgreePrivacy() {
        this.showAgreePrivacy = false;
        this.$store.commit('set', { privacyVisible: false });
      },
      //  按类型统计
      HandlerLeixingChange(e) {
        let _self = this;
        _self.weekcondition.searchType = e;
        _self.BrokenLineStatisticsChart();
      },
      //  Earnings Trend Preview时间选择
      handlerDatePickerPS(e) {
        let _self = this;
        var startDate = e[0];
        startDate = _self.GetStandardStrTime(startDate);
        var endDate = e[1];
        endDate = _self.GetStandardStrTime(endDate);
        _self.weekcondition.startDate = startDate;
        _self.weekcondition.endDate = endDate;
        _self.BrokenLineStatisticsChart();
      },
      //  Percentage Chart时间选择
      handlerDatePickerPC(e) {
        let _self = this;
        var startDate = e[0];
        startDate = _self.GetStandardStrTime(startDate);
        var endDate = e[1];
        endDate = _self.GetStandardStrTime(endDate);
        _self.weekconditionpc.startDate = startDate;
        _self.weekconditionpc.endDate = endDate;
        _self.PercentageStatisticsChart();
      },
      //  中国标准时间转时间字符串
      GetStandardStrTime(nS) {
        //  获取一个时间对象
        var date = new Date(nS);
        //  获取完整的年份(4位,1970)
        let y = date.getFullYear();
        //  获取月份(0-11,0代表1月,用的时候记得加上1)
        let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        //  获取日(1-31)
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return y + "-" + m + "-" + d;
      },
      //  获取统计图数据
      BrokenLineStatisticsChart() {
        let _self = this;
        DataVolumeStatistics.showLoading();
        //  获取配置信息
        let url = this.$url.Consoles.getSalesDay;
        let method = this.$method.get;
        _self.$api
          .request(url, method, _self.weekcondition)
          .then(res => {
            if (res.code === 0) {

              var result = res.data;
              let PSItem = parseInt(_self.PSItem);
              let seriesData = [];
              let xAxisData = [];
              for (let i = 0; i < result.length; i++) {
                let amount = result[i][_self.weekcondition.searchType];
                seriesData.push(amount);
                if (PSItem == 1) {
                  let orderDate = result[i]["orderDate"];
                  xAxisData.push(orderDate);
                } else if (PSItem == 2) {
                  let orderDate = result[i]["orderDate"];
                  let zhouji = _self.StringChangeWeek(orderDate);
                  xAxisData.push(orderDate + " " + zhouji);
                } else {
                  xAxisData.push(result[i]["orderDate"]);
                }
              }
              var series = [
                {
                  name: _self.$t("consoles.xsl"),
                  type: "line",
                  stack: "Total",
                  data: seriesData
                }
              ];
              let textMsg = "";
              if (PSItem == 1) {
                if (_self.weekcondition.searchType == "num") {
                  textMsg = _self.$t("consoles.lcost");
                } else if (_self.weekcondition.searchType == "sales") {
                  textMsg = _self.$t("consoles.lcoste");
                }
              } else if (PSItem == 2) {
                if (_self.weekcondition.searchType == "num") {
                  textMsg = _self.$t("consoles.lwslc");
                } else if (_self.weekcondition.searchType == "sales") {
                  textMsg = _self.$t("consoles.lwslce");
                }
              } else if (PSItem == 3) {
                if (_self.weekcondition.searchType == "num") {
                  textMsg = _self.$t("consoles.slcolm");
                } else if (_self.weekcondition.searchType == "sales") {
                  textMsg = _self.$t("consoles.slcolme");
                }
              } else if (PSItem == 4) {
                textMsg =
                  _self.$t("consoles.zhexianrq2") +
                  _self.weekcondition.startDate +
                  _self.$t("consoles.zhexianrq1") +
                  _self.weekcondition.endDate +
                  _self.$t("consoles.zhexianrq3");
              }
              var chartoption = {
                title: {
                  text: textMsg
                },
                backgroundColor: "#FFFFFF",
                tooltip: {
                  trigger: "axis"
                },
                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: "category",
                  boundaryGap: false,
                  data: xAxisData
                },
                yAxis: {
                  type: "value"
                },
                series: series
              };
              // 绘制图表
              DataVolumeStatistics.clear();
              chartoption && DataVolumeStatistics.setOption(chartoption);
              DataVolumeStatistics.hideLoading();
            }
          })
          .catch(err => {
            this.$notify({
              title: this.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  获取占位图数据
      PercentageStatisticsChart() {
        let _self = this;
        PercentageChart1.showLoading();
        PercentageChart2.showLoading();
        PercentageChart3.showLoading();
        let url = this.$url.Consoles.getProportion;
        let method = this.$method.get;
        _self.$api
          .request(url, method, _self.weekconditionpc)
          .then(res => {
            if (res.code === 0) {

              var data = res.data;
              //  支付方式
              var payTypes = data.payTypeList;
              
              if (payTypes) {
                var pySseriesData = [];
                for (let pyi = 0; pyi < payTypes.length; pyi++) {
                  var payType = payTypes[pyi]["payTypeName"];
                  var payTypeProfit = parseFloat(payTypes[pyi]["profit"]);
                  var pyidata = {
                    value: Math.abs(payTypeProfit),
                    name: payType
                  }
                  pySseriesData.push(pyidata);
                }
                
                var pyoption = {
                  title: {
                    text: _self.$t("consoles.zffszbt"),
                    subtext: "",
                    left: "center"
                  },
                  tooltip: {
                    trigger: "item"
                  },
                  series: [
                    {
                      name: _self.$t("consoles.syrci"),
                      type: "pie",
                      radius: "50%",
                      data: pySseriesData,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                      }
                    }
                  ]
                };
                PercentageChart1.clear();
                pyoption && PercentageChart1.setOption(pyoption);
                PercentageChart1.hideLoading();
              }
              //  设备信息
              var machines = data.equipmentList;
              if (machines) {
                var mSeriesData = [];
                for (let mi = 0; mi < machines.length; mi++) {
                  var equipmentName = machines[mi]["equipmentName"];
                  var machineProfit = parseFloat(machines[mi]["profit"]);
                  var mdata = {
                    value: machineProfit,
                    name: equipmentName
                  };
                  mSeriesData.push(mdata);
                }
                var moption = {
                  title: {
                    text: this.$t("consoles.sbsyzbt"),
                    subtext: "",
                    left: "center"
                  },
                  tooltip: {
                    trigger: "item"
                  },
                  series: [
                    {
                      name: this.$t("consoles.sbsy"),
                      type: "pie",
                      radius: "50%",
                      data: mSeriesData,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                      }
                    }
                  ]
                };
                PercentageChart2.clear();
                moption && PercentageChart2.setOption(moption);
                PercentageChart2.hideLoading();
              }
              //  商品信息
              var product = data.goodsList;
              if (product) {
                var pSeriesData = [];
                for (let pi = 0; pi < product.length; pi++) {
                  var goodsName = product[pi]["goodsName"];
                  var productProfit = parseFloat(product[pi]["profit"]);
                  var pidata = {
                    name: goodsName,
                    value: productProfit
                  };
                  pSeriesData.push(pidata);
                }
                var poption = {
                  title: {
                    text: _self.$t("consoles.spsyzbt"),
                    subtext: "",
                    left: "center"
                  },
                  tooltip: {
                    trigger: "item"
                  },
                  series: [
                    {
                      name: _self.$t("consoles.spsy"),
                      type: "pie",
                      radius: "50%",
                      data: pSeriesData,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                      }
                    }
                  ]
                };
                PercentageChart3.clear();
                poption && PercentageChart3.setOption(poption);
                PercentageChart3.hideLoading();
              }
              //   var pyoption = {
              //     title: {
              //       text: _self.$t("consoles.zffszbt"),
              //       subtext: "",
              //       left: "center"
              //     },
              //     tooltip: {
              //       trigger: "item"
              //     },
              //     series: [
              //       {
              //         name: _self.$t("consoles.syrci"),
              //         type: "pie",
              //         radius: "50%",
              //         data: pySseriesData,
              //         emphasis: {
              //           itemStyle: {
              //             shadowBlur: 10,
              //             shadowOffsetX: 0,
              //             shadowColor: "rgba(0, 0, 0, 0.5)"
              //           }
              //         }
              //       }
              //     ]
              //   };
              //   PercentageChart1.clear();
              //   pyoption && PercentageChart1.setOption(pyoption);
              // }
              
            }           
          })
          .catch(err => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  字符串转周几
      StringChangeWeek(datestring) {
        let _self = this;
        // 确保使用 UTC 时间创建日期，避免时区影响
        const date = new Date(datestring + "T00:00:00Z");
        const weekNum = date.getUTCDay(); //获取今天是周几
        const week = {
          0: _self.$t("consoles.zhouri"),
          1: _self.$t("consoles.zhouyi"),
          2: _self.$t("consoles.zhouer"),
          3: _self.$t("consoles.zhousan"),
          4: _self.$t("consoles.zhousi"),
          5: _self.$t("consoles.zhouwu"),
          6: _self.$t("consoles.zhouliu")
        };
        return week[weekNum] ?? "Date Error";
      },
      //  Earnings Trend Preview
      HandlerPSItem(type) {
        let _self = this;
        //  获取今天日期
        let myDate = new Date();
        // Declare common variables at function level to avoid duplicates
        var flag, dateTemp, startDate, endDate, year, month, day, hour, minute, second, i, enddatetime, startdatetime;
        if (parseInt(type) === 1) {
          //  当前时间年月日时分秒
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          enddatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          //  昨天的时间
          myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          startdatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          _self.datastringps = [new Date(startdatetime), new Date(enddatetime)];
          _self.weekcondition.startDate = startdatetime;
          _self.weekcondition.endDate = enddatetime;
          _self.weekcondition.type = 1;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 2) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 7);
          for (i = 0; i < 7; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            if (parseInt(date) < 10) {
              date = "0" + date;
            }
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 6) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringps = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          _self.weekcondition.startDate = startDate;
          _self.weekcondition.endDate = endDate;
          _self.weekcondition.type = 2;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 3) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 30);
          for (i = 0; i < 30; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            if (parseInt(date) < 10) {
              date = "0" + date;
            }
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 29) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringps = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          _self.weekcondition.startDate = startDate;
          _self.weekcondition.endDate = endDate;
          _self.weekcondition.type = 2;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 4) {
          if (_self.PSItem === 1) {
            //  当前时间年月日时分秒
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            enddatetime = year + "-" + month + "-" + day;
            //  昨天的时间
            myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            //  获取统计数据
            startdatetime = year + "-" + month + "-" + day;
            _self.datastringps = [new Date(startdatetime + " 00:00:00"), new Date(enddatetime + " 23:59:59")];
            _self.weekcondition.startDate = startdatetime;
            _self.weekcondition.endDate = enddatetime;
          }
          _self.weekcondition.type = 2;
        }
        _self.PSItem = type;
      },
      //  Percentage Chart
      HandlerPCItem(type) {
        let _self = this;
        //  获取今天日期
        var myDate = new Date();
        // Declare common variables at function level to avoid duplicates
        var flag, dateTemp, startDate, endDate, year, month, day, hour, minute, second, i, enddatetime, startdatetime;
        if (parseInt(type) === 1) {
          //  当前时间年月日时分秒
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          enddatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          //  昨天的时间
          myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          startdatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          _self.datastringpc = [new Date(startdatetime), new Date(enddatetime)];
          _self.weekconditionpc.startDate = startdatetime;
          _self.weekconditionpc.endDate = enddatetime;
          _self.PercentageStatisticsChart();
        } else if (parseInt(type) === 2) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 7);
          for (i = 0; i < 7; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 6) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringpc = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          //  获取统计数据
          _self.weekconditionpc.startDate = startDate;
          _self.weekconditionpc.endDate = endDate;
          _self.PercentageStatisticsChart();
        } else if (parseInt(type) === 3) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 30);
          for (i = 0; i < 30; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 29) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringpc = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          //  获取统计数据
          _self.weekconditionpc.startDate = startDate;
          _self.weekconditionpc.endDate = endDate;
          _self.PercentageStatisticsChart();
        } else if (parseInt(type) === 4) {
          if (_self.PCItem === 1) {
            //  当前时间年月日时分秒
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            enddatetime = year + "-" + month + "-" + day;
            //  昨天的时间
            myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            //  获取统计数据
            startdatetime = year + "-" + month + "-" + day;
            _self.datastringpc = [new Date(startdatetime + " 00:00:00"), new Date(enddatetime + " 23:59:59")];
            _self.weekconditionpc.startDate = startdatetime;
            _self.weekconditionpc.endDate = enddatetime;
          }
        }
        _self.PCItem = type;
      },
      //  获取设备数量
      getMachines() {
        let _self = this;
        // Use proper dashboard API for real-time machine counts
        let url = this.$url.Consoles.getMachine;
        let method = this.$method.get;
        this.$api
          .request(url, method, {})
          .then(res => {
            if (res.code === 0) {
              // Use backend data directly - no frontend calculation needed
              _self.machines = res.data;
            }
          })
          .catch(err => {
            // Fallback to user equipment API if dashboard API fails
            let fallbackUrl = this.$url.UserMachine.page;
            let params = {
              pageSize: 100,
              pageIndex: 1
            };
            this.$api
              .request(fallbackUrl, method, params)
              .then(res => {
                if (res.code === 0) {
                  // Transform user equipment response to dashboard format
                  let response = {
                    equipmentTotalNum: res.data.total || 0,
                    equipmentMqYesNum: 0, // Count online machines
                    equipmentMqNoNum: 0   // Count offline machines
                  };
                  
                  // Count online/offline machines if records available
                  if (res.data.records && res.data.records.length > 0) {
                    res.data.records.forEach(machine => {
                      if (machine.mqState === 1 || machine.mqState === '1') {
                        response.equipmentMqYesNum++;
                      } else {
                        response.equipmentMqNoNum++;
                      }
                    });
                    // If we only got partial records, estimate based on total
                    if (res.data.total > res.data.records.length) {
                      let ratio = res.data.records.length / res.data.total;
                      response.equipmentMqYesNum = Math.round(response.equipmentMqYesNum / ratio);
                      response.equipmentMqNoNum = response.equipmentTotalNum - response.equipmentMqYesNum;
                    }
                  }
                  
                  _self.machines = response;
                }
              })
              .catch(fallbackErr => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: fallbackErr.msg,
                  type: "error"
                });
              });
          });
      },
      //  今日销售额
      getDaySales() {
        let _self = this;
        //  获取配置信息
        let url = this.$url.Consoles.getSales;
        let method = this.$method.get;
        this.$api
          .request(url, method, {})
          .then(res => {
            if (res.code === 0) {
              let response = res.data;
              _self.daySales = response;
            }
          })
          .catch(err => {
            this.$notify({
              title: this.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  排行榜日期改变
      PhHandlerDateChange(data) {
        let _self = this;
        if (data && data.length > 0) {
          _self.search.startDate = _self.GetStandardStrTimes(data[0]);
          _self.search.endDate = _self.GetStandardStrTimes(data[1]);
        } else {
          _self.search.startDate = "";
          _self.search.endDate = "";
        }
        if (_self.activeName == "first") {
          _self.getSalesUser();
        } else if (_self.activeName == "second") {
          _self.getSalesMachine();
        } else if (_self.activeName == "third") {
          _self.getSalesProduct();
          _self.getUserMachine();
        }
      },
      //  排行榜Tab切换
      HandleSwitcPage(tab) {
        let _self = this;
        if (parseInt(tab.index) == 0) {
          _self.getSalesUser();
        } else if (parseInt(tab.index) == 1) {
          _self.getSalesMachine();
        } else if (parseInt(tab.index) == 2) {
          _self.getSalesProduct();
          _self.getUserMachine();
        }
      },
      //  排行榜类型排序
      handlerSortChange(e) {
        let _self = this;
        if (_self.activeName == "first") {
          _self.getSalesUser();
        } else if (_self.activeName == "second") {
          _self.getSalesMachine();
        } else if (_self.activeName == "third") {
          _self.getSalesProduct();
          _self.getUserMachine();
        }
      },
      //  中国标准时间转时间字符串
      GetStandardStrTimes(nS) {
        //  获取一个时间对象
        var date = new Date(nS);
        //  获取完整的年份(4位,1970)
        let y = date.getFullYear();
        //  获取月份(0-11,0代表1月,用的时候记得加上1)
        let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        //  获取日(1-31)
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        //  获取时(1-24)
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        //  获取分(1-60)
        let f = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        //  获取分(1-60)
        let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
      },
      //  用户榜
      getSalesUser(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesUser;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                if (response.length >= _self.page.pageSize) {
                  _self.ismore = 1;
                } else {
                  _self.ismore = 0;
                }
              } else {
                _self.datasets = [];
                _self.ismore = 0;
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  商品榜
      getSalesProduct(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesProduct;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                //  商品统计条形图
                let xAxisData1 = [];
                let seriesData1 = [];
                for (let j = 0; j < response.length; j++) {
                  let goodsName = response[j]["goodsName"];
                  xAxisData1.push(goodsName);
                  let values = 0;
                  if (_self.weekcondition.searchType == "num") {
                    values = parseFloat(response[j]["num"]);
                  } else if (_self.weekcondition.searchType == "sales") {
                    values = parseFloat(response[j]["sales"]);
                  }
                  seriesData1.push(values);
                }
                var sptjChart = echarts.init(document.getElementById("ProductChart"));
                var sptjOption = {
                  xAxis: {
                    type: "category",
                    data: xAxisData1,
                    axisLabel: {
                      interval: 0,
                      formatter: function (value) {
                        // 如果标签长度超过8个字符，截断并添加省略号
                        if (value.length > 8) {
                          return value.substring(0, 8) + "...";
                        }
                        return value;
                      },
                      rotate: 0,
                      fontSize: 12
                    }
                  },
                  yAxis: {
                    type: "value"
                  },
                  series: [
                    {
                      data: seriesData1,
                      type: "bar"
                    }
                  ]
                };
                sptjOption && sptjChart.setOption(sptjOption);
              } else {
                _self.datasets = [];
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  设备榜
      getSalesMachine(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesMachine;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                if (response.length >= _self.page.pageSize) {
                  _self.ismore = 1;
                } else {
                  _self.ismore = 0;
                }
              } else {
                _self.datasets = [];
                _self.ismore = 0;
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  用户设备
      getUserMachine(pageIndex) {
        let _self = this;
        _self.$api
          .request(_self.$url.Theme.machinepage, _self.$method.get, {})
          .then(res => {
            if (res.code === 0) {
              let records = res.data.records;
              _self.MachineData = records;
              _self.MachinePage.totalSize = parseInt(res.data.total);
            }
          })
          .catch(() => {});
      }
    }
  };
</script>

<style lang="scss">
  .activeyanse {
    color: #50c5ab;
  }

  .yanse {
    color: #000000;
  }

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    // border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>
